import React from 'react';
import Countdown from 'react-countdown';

import Container from '../components/Container';
import Flex from '../components/Flex';
import Spacing from '../components/Spacing';
import Text from '../components/Text';
import Link from '../components/Link';

const CountdownContainer = () => (
  <Flex
    justifyContent="center"
    className="bg-gray-900 text-gray-100 shadow-2xl"
  >
    <Flex
      alignItems="center"
      className="max-w-screen-lg mx-auto h-12"
    >
      <Spacing right={2}>
        <span aria-label="Descuento" role="img">
          🔥
        </span>
      </Spacing>
      <Spacing right={1}>
        <Text className="font-medium">
          Precio Early Bird
        </Text>
      </Spacing>
      <Flex alignItems="center">
        <Spacing h={1}>
          <Text className="line-through text-gray-500">
            $2100
          </Text>
        </Spacing>
        <Spacing h={1}>
          <Text className="text-red-500 font-semibold">
            $950
          </Text>
        </Spacing>
        <Spacing right={2}>
          <span aria-label="Descuento" role="img">
            🔥
          </span>
        </Spacing>
        <Flex alignItems="center">
          <Spacing right={1}>
            <Text className="font-medium">
              Finaliza en
            </Text>
          </Spacing>
          <Container className="text-red-500 font-semibold">
            <Countdown
              date="2020-06-01"
              renderer={
                ({
                  days,
                  hours,
                  minutes,
                  seconds,
                }) => (
                  <Flex alignItems="center">
                    <Spacing>
                      {days}
                      d
                    </Spacing>
                    :
                    <Spacing>
                      {hours}
                      h
                    </Spacing>
                    :
                    <Spacing>
                      {minutes}
                      m
                    </Spacing>
                    :
                    <Spacing>
                      {seconds}
                      s
                    </Spacing>
                  </Flex>
                )
              }
            />
          </Container>
          <Spacing left={2}>
            <Link className="bg-green-500 text-white inline-flex px-2 py-1 rounded-sm font-medium text-sm text-center whitespace-no-wrap justify-center" href="https://www.aibes.org/pago/?add-to-cart=1973&amp;ref=official-agile-coach-training" target="_blank" rel="noopener noreferrer" role="button">
              Inscríbete hoy mismo
            </Link>
          </Spacing>
        </Flex>
      </Flex>
    </Flex>
  </Flex>
);

export default CountdownContainer;
